export default {
    data() {
        return {
            maxFileSize: {
                max_file_size_mb: 0,
                max_file_size_b: 0,
                warning: '',
            },
        }
    },
    methods: {
        loadMaxFileSize(warning) {
            this.isLoading = true;

            this.$api.get('v1/admin/files/max-size/' + warning).then(response => {
                if (response.data) {
                    this.maxFileSize = response.data;
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
    }
}
